import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/multi-language/language.service';
import { CpCompanyService } from 'src/app/admin/tf-admin/tf-configuration/tf-company/service/cp-company.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-nav-logo',
  templateUrl: './nav-logo.component.html',
  styleUrls: ['./nav-logo.component.scss']
})
export class NavLogoComponent implements OnInit, OnDestroy {

  // public props
  @Input() navCollapsed: boolean;
  @Output() NavCollapse = new EventEmitter();
  windowWidth = window.innerWidth;
  langset: any;
  logoImageUrl: string;
  companyName: string;
  private subscriptions: Subscription[] = [];

  constructor(
    public translate: TranslateService,
    public langService: LanguageService,
    private cpCompanyService: CpCompanyService
  ) {
    this.windowWidth = window.innerWidth;
    this.langset = this.translate.getBrowserLang();
    // localStorage.setItem("lang", this.langset);
  }

  ngOnInit(): void {
    // Subscribe to the logo URL from the service (already loaded during app initialization)
    const logoSub = this.cpCompanyService.pictureUrlLogo$.subscribe(url => {
      if (url) {
        this.logoImageUrl = url;
      }
    });
    this.subscriptions.push(logoSub);

    // Get initial logo URL if already loaded
    const currentLogoUrl = this.cpCompanyService.getCurrentLogoUrl();
    if (currentLogoUrl) {
      this.logoImageUrl = currentLogoUrl;
    }

    // Subscribe to company name from the service (already loaded during app initialization)
    const nameSub = this.cpCompanyService.companyName$.subscribe(name => {
      if (name) {
        this.companyName = name;
      }
    });
    this.subscriptions.push(nameSub);

    // Get initial company name if already loaded
    const currentCompanyName = this.cpCompanyService.getCurrentCompanyName();
    if (currentCompanyName) {
      this.companyName = currentCompanyName;
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions = [];
  }
  // public method
  navCollapse() {
    if (this.windowWidth >= 992) {
      this.navCollapsed = !this.navCollapsed;
      this.NavCollapse.emit();
    }
  }
}
